import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN, USER_ROLE } from "@/store/mutation-types";
import { HomeLayout, LoginLayout, StudentLayout, TeacherLayout, TeachCenterLayout, LogoLayout } from './layouts'
import { BlankLayout } from '@/components/layouts'

const whiteList = ['/user/login', '/index'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(Vue.ls.get(ACCESS_TOKEN));
  if (Vue.ls.get(ACCESS_TOKEN)) {
    if (to.path === '/user/login') {
      if(to.query.role === 'teacher'){
        next({ path: '/teacher' })
      }else{
        next({ path: '/student' })
      }
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next({ path: '/user/login', query: { redirect: to.fullPath, role: Vue.ls.get(USER_ROLE) } })
    }else{
      next()
    }
  }
})
let tenantConfig = store.getters.tenantInfo
/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    name: 'home',
    redirect: tenantConfig && tenantConfig.home || '/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'home',
        component: () => import(/* webpackChunkName: "xmw" */ './views/home/Home')
      }
    ]
  },
  {
    path: '/user',
    component: LoginLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "xmw" */ './views/user/Login')
      },
    ]
  },
  {
    path: '/student',
    component: StudentLayout,
    redirect: '/student/course',
    children: [
      {
        path: 'center',
        name: 'studentCenter',
        component: () => import(/* webpackChunkName: "xmw" */ './views/user/UserCenter')
      },
      {
        path: 'course',
        name: 'studentCourse',
        component: () => import(/* webpackChunkName: "xmw" */ './views/student/StudentCourse')
      },
      {
        path: 'work',
        name: 'studentWork',
        component: () => import(/* webpackChunkName: "xmw" */ './views/student/StudentWork')
      },
      {
        path: 'score',
        name: 'studentScore',
        component: () => import(/* webpackChunkName: "xmw" */ './views/student/StudentScore')
      },
      {
        path: 'greatWork',
        name: 'greatWork',
        component: () => import(/* webpackChunkName: "xmw" */ './views/student/StudentGreatWork')
      },
    ]
  },
  {
    path: '/student/studentCenter',
    component: BlankLayout,
    redirect: '/student/studentCenter/studentCourseUnit',
    children: [
      {
        path: 'studentCourseUnit',
        name: 'studentCourseUnit',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/student/StudentCourseUnitList')
      },
    ],
  },
  {
    path: '/teacher',
    component: TeacherLayout,
    redirect: '/teacher/report',
    children: [
      {
        path: 'center',
        name: 'teacherCenter',
        component: () => import(/* webpackChunkName: "xmw" */ './views/user/UserCenter')
      },
      {
        path: 'report',
        name: 'report',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherReport')
      },
      {
        path: 'course',
        name: 'course',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherCourseList')
      },
      {
        //作业列表
        path: 'workGroup',
        name: 'workGroup',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherWorkGroup')
      },
      {
        //作业列表
        path: 'workList',
        name: 'workList',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherWorkList')
      },
      {
        //作业列表课程单元包装
        path: 'workUnit',
        name: 'workUnit',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherWorkListUnitWrap')
      },
      {
        path: 'additionWork',
        name: 'additionWork',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherAdditionWork')
      },
      {
        path: 'student',
        name: 'student',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherStudent')
      },
      {
        path: 'depart',
        name: 'depart',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherDepart')
      },

    ]
  },
  {
    path: '/teacher/teachingCenter',
    component: TeachCenterLayout,
    redirect: '/teacher/teachingCenter/teacherCourseUnit',
    children: [
      {
        path: 'teacherCourseUnit',
        name: 'teacherCourseUnit',
        component: ()=> import(/* webpackChunkName: "xmw" */ './views/teacher/TeacherCourseUnitList')
      },
    ],
  }
]
export default RouterMap